/* State pattern:
*
* {
*     activeSection: 'identificator of active panel :inspector, plugin settings',
      adData: {
          isValid: true,
          sas_format_linears: '',
          sas_format_overlays: '',
          sas_networkid: '',
          sas_pageid: '',
          sas_siteid: '',
          sas_target: ''
      },
      adRules: {
        data: [{
            duration_min: 0,
            duration_max: -1,
            data: {
                midrolls: {
                    instances: 1,
                    interval: 50,
                    maxAdPodDuration: 50,
                    offset: 50,
                    percents: [10, 50],
                    time: ['00:00:15', '01:30.500', '01:30:00.000']
                }, overlays: {
                    instances: 1,
                    interval: 50,
                    offset: 50,
                    percents: [10, 50],
                    time: ['00:00:15', '01:30.500', '01:30:00.000']
                },
                prerolls: {
                    instances: 1,
                    maxAdPodDuration: 50
                },
                postrolls: {
                    instances: 1,
                    maxAdPodDuration: 50
                }
            }
        }],
        isValid: true
      },
      configuration: {
        isValid: true,
        labels: {
            lbl_countdown_break_midroll: {
                "EN": 'Your content will resume in {0}'
            },
            lbl_countdown_break_postroll: {
                "EN": 'End of ad break in {0}'
            },
            lbl_countdown_break_preroll: {
                "EN": 'Your content will start in {0}'
            },
            lbl_countdown_skip: {
                "EN": 'You can skip this ad in {0} seconds'
            },
            lbl_more: {
                "EN": 'More...'
            },
            lbl_skip_vpaid: {
                "EN": 'You can skip this interactive ad'
            }
        },
        overlays: {
            hideDuringPause: true,
            resize: true
        },
        companions: {
            remove: true,
            slot: 'testCompanion'
        }
        banner: {
            sas_format_banners: '',
            sas_target_banners: ''
        }
        player: {
            autoHideControls: true,
            controlBarMode: 'CONTROL_BAR_MODE_FLOATING',
            enableCountdownSkip: true,
            enableCountdownVideo: true,
            enableFullscreen: true,
            enablePause: false,
            enableSound: true,
            scaleMode: 'SCALE_MODE_LETTERBOX'
        },
        publisher: {
            activeControlsForEmbededAdManager: true,
            allowConditionalAd: true,
            bumperDuration: 0,
            bumperPreAdUrl: "",
            bumperPostAdUrl: "",
            checkUniversalAdId: false,
            countdownTimeFormat: "mm:ss",
            enableAdPauseOnWindowChange: true,
            enableMobileClickThroughButton: false,
            forceSkipDelay: false,
            html5SeamlessFullscreen: false,
            integralAdScienceAnId: -1,
            loadHlsJsLibrary: false,
            muteAdsAtStartup: false,
            numberOfPassbackAds: -1,
            numMaxRedirect: 5,
            pauseMainContentUntilVASTIsLoaded: true,
            replayAd: true,
            requestTimeout: 3,
            skipDelay: 10,
            totalTimeout: 8,
            unmuteOnMouseOver: false,
            visibilityThresholdForPlayback: -1,
            visibilityThresholdForUnmute: -1,
            enableSSAR: false,
            schain: ""
        },
        rtb: {
            vdmin: '',
            vdmax: '',
            vbrmin: '',
            vbrmax: '',
            vpmt: '',
            pgDomain: ''
        },
        vpaid: {
            enableCountdownVideo: true,
            enableSkip: true,
            enableSkipLabel: true,
            generalTimeout: 3,
            handleSkipOffset: false,
            initTimeout: 3,
            loadTimeout: 3,
            totalTimeout: 5
        }
    },
    other: {
        isValid: true,
        user: {
            uid: ''
        },
        content: {
            sas_contentid: '',
            sas_videoContentDuration: null
        }
    }
    logs: [],
    player: {
        autoplay: false,
        containerId: "container",
        name: "jwplayer",
        version: 1
    }
    vastInspector: {
        vast: "An url or plain text for vast to valid"
    },
    subTab: 0,
    companionWidth,
    companionHeight,
    configurationUrl: {
        loading: false,
        value: ''
    }
}
*
*/

import {
  CLEAR_LOGS,
  RELOAD_PLAYER,
  RESET_DATA,
  START_TEST,
  UPDATE_ACTIVE_SECTION,
  UPDATE_AD_RULES,
  UPDATE_CONFIGURATION,
  UPDATE_LOGS,
  UPDATE_PLACEMENT_DATA,
  UPDATE_OTHER_SETTINGS,
  UPDATE_SUB_TAB,
  UPDATE_VAST_FOR_INSPECT,
  IMPORT_SETTINGS,
  UPDATE_IMPORT_POPUP,
  SET_SSAR,
  UPDATE_BANNER_DATA,
  UPDATE_COMPANION_SLOT,
  POST_CONFIGURATION_SUCCESS,
  FETCH_CONFIGURATION_SUCCESS,
  UPDATE_VAST_CONFIGURATION_URL,
  POST_CONFIGURATION_FAILURE,
  POST_CONFIGURATION_REQUEST,
} from '../actions/index';
import { setLocalStorage } from '../helpers/tools';
import { sections } from '../constants/Constants';

const showcaseReducer = (state = {}, action) => {
  switch (action.type) {
    case CLEAR_LOGS:
      return Object.assign({}, state, {
        logs: [],
        vastSource: state.vastSource,
      });
    case IMPORT_SETTINGS:
      return Object.assign({}, state, {
        adData: JSON.parse(JSON.stringify(action.data.adData)),
        adRules: JSON.parse(JSON.stringify(action.data.adRules)),
        configuration: JSON.parse(JSON.stringify(action.data.configuration)),
        other: JSON.parse(JSON.stringify(action.data.other)),
      });
    case UPDATE_IMPORT_POPUP:
      return Object.assign({}, state, {
        importPopupOpen: action.data,
      });
    case RELOAD_PLAYER:
      return Object.assign({}, state, {
        player: {
          autoplay: state.player.autoplay,
          containerId: state.player.containerId,
          name: action.name,
          version: action.version,
        },
      });
    case RESET_DATA:
      return Object.assign({}, state, JSON.parse(JSON.stringify(action.data)));
    case SET_SSAR:
      return Object.assign({}, state, {
        configuration: {
          ...state.configuration,
          publisher: {
            ...state.configuration.publisher,
            enableSSAR: action.active,
          },
        },
      });
    case START_TEST:
      if (state.activeSection === sections.VAST_INSPECTOR) {
        return Object.assign({}, state, {
          logs: [],
        });
      } else {
        return state;
      }
    case UPDATE_ACTIVE_SECTION:
      return Object.assign({}, state, {
        activeSection: action.index,
      });
    case UPDATE_AD_RULES:
      let adRules = JSON.parse(JSON.stringify(action.adRules));

      return Object.assign({}, state, {
        adRules: adRules,
      });
    case UPDATE_CONFIGURATION:
      return Object.assign({}, state, {
        configuration: {
          isValid: action.data.isValid,
          labels: {
            lbl_countdown_skip: {
              EN:
                action.data.labels.lbl_countdown_skip.EN !== undefined
                  ? action.data.labels.lbl_countdown_skip.EN
                  : action.data.labels.lbl_countdown_skip,
            },
            lbl_countdown_break_preroll: {
              EN:
                action.data.labels.lbl_countdown_break_preroll.EN !== undefined
                  ? action.data.labels.lbl_countdown_break_preroll.EN
                  : action.data.labels.lbl_countdown_break_preroll,
            },
            lbl_countdown_break_midroll: {
              EN:
                action.data.labels.lbl_countdown_break_midroll.EN !== undefined
                  ? action.data.labels.lbl_countdown_break_midroll.EN
                  : action.data.labels.lbl_countdown_break_midroll,
            },
            lbl_countdown_break_postroll: {
              EN:
                action.data.labels.lbl_countdown_break_postroll.EN !== undefined
                  ? action.data.labels.lbl_countdown_break_postroll.EN
                  : action.data.labels.lbl_countdown_break_postroll,
            },
            lbl_skip_vpaid: {
              EN:
                action.data.labels.lbl_skip_vpaid.EN !== undefined
                  ? action.data.labels.lbl_skip_vpaid.EN
                  : action.data.labels.lbl_skip_vpaid,
            },
            lbl_more: {
              EN:
                action.data.labels.lbl_more.EN !== undefined
                  ? action.data.labels.lbl_more.EN
                  : action.data.labels.lbl_more,
            },
          },
          overlays: action.data.overlays,
          companions: action.data.companions,
          banner: state.configuration.banner,
          player: action.data.player,
          publisher: action.data.publisher,
          rtb: action.data.rtb,
          vpaid: action.data.vpaid,
        },
      });
    case UPDATE_LOGS:
      if (action.logs.log !== undefined && action.logs.log.length > 0) {
        return Object.assign({}, state, {
          logs: state.logs.concat({
            log: action.logs.log,
            time: action.logs.time,
            type: action.logs.type,
          }),
        });
      } else {
        return state;
      }
    case UPDATE_PLACEMENT_DATA:
      return Object.assign({}, state, {
        adData: {
          isValid: action.data.isValid,
          sas_format_linears: action.data.sas_format_linears,
          sas_format_overlays: action.data.sas_format_overlays,
          sas_networkid: action.data.sas_networkid,
          sas_pageid: action.data.sas_pageid,
          sas_siteid: action.data.sas_siteid,
          sas_target: action.data.sas_target,
        },
      });
    case UPDATE_BANNER_DATA:
      return Object.assign({}, state, {
        configuration: {
          ...state.configuration,
          banner: {
            sas_format_banners: action.data.sas_format_banners,
            sas_target_banners: action.data.sas_target_banners,
          },
        },
      });
    case UPDATE_OTHER_SETTINGS:
      return Object.assign({}, state, {
        other: {
          isValid: action.data.isValid,
          user: action.data.user,
          content: action.data.content,
        },
      });
    case UPDATE_SUB_TAB:
      return Object.assign({}, state, {
        subTab: action.index,
      });
    case UPDATE_VAST_FOR_INSPECT:
      return Object.assign({}, state, {
        vastSource: action.vastSource,
      });
    case UPDATE_COMPANION_SLOT:
      return Object.assign({}, state, {
        companionWidth: action.data.width,
        companionHeight: action.data.height,
      });
    case UPDATE_VAST_CONFIGURATION_URL: {
      return Object.assign({}, state, {
        configurationUrl: {
          loading: false,
          value: action.vastSource,
        },
      });
    }
    case POST_CONFIGURATION_REQUEST:
      return Object.assign({}, state, {
        configurationUrl: {
          loading: true,
          value: '',
        },
      });
    case POST_CONFIGURATION_SUCCESS:
      return Object.assign({}, state, {
        configurationUrl: {
          loading: false,
          value: action.url,
        },
      });
    case POST_CONFIGURATION_FAILURE:
      return Object.assign({}, state, {
        configurationUrl: {
          loading: false,
          value: action.message,
        },
      });
    case FETCH_CONFIGURATION_SUCCESS:
      setLocalStorage('adData', JSON.stringify(action.data.adData));
      setLocalStorage('adRules', JSON.stringify(action.data.adRules));
      setLocalStorage('configuration', JSON.stringify(action.data.configuration));
      setLocalStorage('other', JSON.stringify(action.data.other));

      return Object.assign({}, state, {
        adData: JSON.parse(JSON.stringify(action.data.adData)),
        adRules: JSON.parse(JSON.stringify(action.data.adRules)),
        configuration: JSON.parse(JSON.stringify(action.data.configuration)),
        other: JSON.parse(JSON.stringify(action.data.other)),
      });
    default:
      return state;
  }
};

export default showcaseReducer;
